import React, { useState } from "react";
import Logo from "../../assets/images/logo.png";
import LogoDark from "../../assets/images/logo-dark.png";
import Head from "../../layout/head/Head";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Block,
  BlockContent,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard,
} from "../../components/Component";
import { Form, Spinner } from "reactstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate } from "react-router-dom";

import { LoginSchema } from "../../validations/UserValidation";
import { loginAPI } from "../../api/auth";
import { useUserInfo } from "../../layout/provider/Theme";

const Login = () => {
  const { handleUserInfo } = useUserInfo();
  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(LoginSchema),
  });

  const onFormSubmit = async (formData) => {
    setLoading(true);
    try {
      const response = await loginAPI({
        email: formData.email.toLowerCase(),
        password: formData.password,
      });
      localStorage.setItem("accessToken", response.data.data.token);
      localStorage.setItem("role", response.data.data.role);
      navigate("/");
      toast.success(response.data.message, {
        position: "top-center",
      });
      await handleUserInfo();
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-center",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Head title="Login" />
      <Block className="nk-block-middle nk-auth-body  wide-xs">
        <div className="brand-logo pb-4 text-center">
          <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
            <img
              className="logo-light logo-img logo-img-lg"
              src={Logo}
              alt="logo"
            />
            <img
              className="logo-dark logo-img logo-img-lg"
              src={LogoDark}
              alt="logo-dark"
            />
          </Link>
        </div>

        <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
          <BlockHead>
            <BlockContent>
              <BlockTitle tag="h4">Sign-In</BlockTitle>
            </BlockContent>
          </BlockHead>
          <Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
            <div className="form-group">
              <div className="form-label-group">
                <label className="form-label" htmlFor="default-01">
                  Email
                </label>
              </div>
              <div className="form-control-wrap">
                <input
                  type="text"
                  id="default-01"
                  {...register("email", {
                    setValueAs: (value) => value.trim(),
                  })}
                  placeholder="Enter your email address"
                  className={`form-control-lg form-control ${
                    errors.email ? "error" : ""
                  }`}
                />
                {errors.email && (
                  <span className="custom-invalid">{errors.email.message}</span>
                )}
              </div>
            </div>
            <div className="form-group">
              <div className="form-label-group">
                <label className="form-label" htmlFor="password">
                  Password
                </label>
              </div>
              <div className="form-control-wrap">
                <a
                  href="#password"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setPassState(!passState);
                  }}
                  className={`form-icon lg form-icon-right passcode-switch ${
                    passState ? "is-hidden" : "is-shown"
                  }`}
                >
                  <Icon name="eye" className="passcode-icon icon-show"></Icon>

                  <Icon
                    name="eye-off"
                    className="passcode-icon icon-hide"
                  ></Icon>
                </a>
                <input
                  type={passState ? "text" : "password"}
                  id="password"
                  {...register("password", {
                    setValueAs: (value) => value.trim(),
                  })}
                  placeholder="Enter your password"
                  className={`form-control-lg form-control ${
                    errors.password ? "error" : ""
                  }`}
                />
                {errors.password && (
                  <span className="custom-invalid">
                    {errors.password.message}
                  </span>
                )}
              </div>
            </div>
            <div className="form-group">
              <Button
                size="lg"
                className="btn-block"
                type="submit"
                color="primary"
                disabled={loading}
              >
                {loading ? <Spinner size="sm" color="light" /> : "Sign in"}
              </Button>
            </div>
          </Form>
        </PreviewCard>
      </Block>
    </>
  );
};

export default Login;
